import { render, staticRenderFns } from "./ElFormSub.vue?vue&type=template&id=17ae44ca"
import script from "./ElFormSub.vue?vue&type=script&lang=js"
export * from "./ElFormSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports